/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from 'react';

export interface EventCardComponents {
  VerticalEventCard: React.ComponentType<any>;
  EventCardPrice: React.ComponentType<any>;
  EventCardLocation: React.ComponentType<any>;
  EventCardDate: React.ComponentType<any>;
  EventCardTitle: React.ComponentType<any>;
  EventCardImage: React.ComponentType<any>;
  EventCardPromoted: React.ComponentType<any>;
  EventCardTracking: React.ComponentType<any>;
}

export const useEventCardComponents = (): EventCardComponents | null => {
  const [components, setComponents] = useState<EventCardComponents | null>(null);

  useEffect(() => {
    const loadComponents = async () => {
      try {
        const eventRendererModule = await import('@eventbrite/consumer-search.event-renderer');

        setComponents({
          VerticalEventCard: eventRendererModule.VerticalEventCard,
          EventCardPrice: eventRendererModule.EventCardPrice,
          EventCardLocation: eventRendererModule.EventCardLocation,
          EventCardDate: eventRendererModule.EventCardDate,
          EventCardTitle: eventRendererModule.EventCardTitle,
          EventCardImage: eventRendererModule.EventCardImage,
          EventCardPromoted: eventRendererModule.EventCardPromoted,
          EventCardTracking: eventRendererModule.EventCardTracking,
        });
      } catch (error) {
        console.error('Could not load components from consumer-search.event-renderer:', error);
      }
    };

    loadComponents();
  }, []);

  return components;
};
